import React from 'react';
import { connect } from 'react-redux';
import { t } from 'ttag';
import style from './footer.scss';
import NavigationActions from '../../redux/navigationRedux';
import getStepTitle from '../../services/helper/stepTitle';

const FooterView = ({ navigateForward, navigateBackward, navigation, loading, model }) => {
    const { forwardNavigation, backwardNavigation, active, items } = navigation;
    let nextStepButton = null;
    let nextButtonStyle = style.nextButton;
    let backButtonStyle = style.backButton;
    let navigationPossible = true;

    if (loading || model === null) {
        nextButtonStyle = style.disabledNextButton;
        backButtonStyle = style.disabledBackButton;
        navigationPossible = false;
    }

    if (forwardNavigation) {
        nextStepButton = (
            <button
                className={nextButtonStyle}
                onClick={navigationPossible ? () => navigateForward() : null}
                disabled={!forwardNavigation}
            >
                <div className={style.nextIcon} />
                <h2>{t`Weiter`}: {getStepTitle(items[active + 1].name)}</h2>
            </button>
        );
    }

    return (
        <div className={style.container}>
            <div className={style.navigationButtons}>
                <button
                    className={backButtonStyle}
                    onClick={navigationPossible ? () => navigateBackward() : null}
                    disabled={!backwardNavigation}
                >
                    <div className={style.backIcon} />
                    <h2>{t`Zurück`}: {getStepTitle(items[active - 1].name)}</h2>
                </button>
                {nextStepButton}
            </div>
            <hr />
            <p className={style.disclaimer}>
                {t`* Alle Preise sind unverbindliche Preisempfehlungen der La Strada
                Fahrzeugbau GmbH an die autorisierten Partner (ab Werk inkl. 19% MwSt).
                Die Sonderausstattungspreise gelten nur für den Einbau im Herstellerwerk.
                Wir bemühen uns stets, Ihnen die aktuell gültigen Preise zu nennen.
                Dennoch kann es in Ausnahmefällen vorkommen, dass die Preisangaben nicht
                tagesaktuell sind.`}
            </p>
        </div>
    );
};

const mapStateToProps = state => ({
    navigation: state.navigation,
    loading: state.parts.fetching,
    model: state.configuration.model,
});

const mapDispatchToProps = dispatch => ({
    navigateForward: () => dispatch(NavigationActions.navigateForward()),
    navigateBackward: () => dispatch(NavigationActions.navigateBackward()),
});

const Footer = connect(
    mapStateToProps,
    mapDispatchToProps
)(FooterView);

export default Footer;

